module.exports = __webpack_public_path__ + "img/Daniela-Dimitrova.b01d82bf.jpeg";